import React from "react";

const Header = () => {

    return <header className="header" >
        <img src="./img/logo.png" alt="logo Briskly" /> <h2>EcoSystem</h2>
    </header>
}

export default Header;